import {ENDPOINT_ADMIN_COMMISSIONS_LIST} from "../../constants/api";

const CancelablePromise = require('mn-utils/CancelablePromise');
const map = require('mn-utils/map');
const {
  apiRequestAdmin,
} = require('../ws');


export function apiAdminCommissionsList(params) {
  params = params || {};
  const offset = params.offset || 0;
  const limit = params.limit || 50;
  return (() => {
    if (process.env.MOCK) {
      const items = [
        {
          id: '1',
          blockchain: 'ETH',
          updated_date: '2020-02-17T12:07',
          status: 'outdated',
          fee: 110000000000.000000,
        },
        {
          id: '2',
          blockchain: 'BTC',
          updated_date: '2020-02-17T12:07',
          status: 'ok',
          fee: 88.000000,
        },
      ];
      return CancelablePromise.delay(500, {
        list: items.slice(offset, offset + limit),
        count: items.length,
      });
    }
    return apiRequestAdmin(ENDPOINT_ADMIN_COMMISSIONS_LIST, {
      ...params,
      offset,
      limit,
    });
  })().then((v) => {
    return {
      ...v,
      list: map(v.list, (item) => {
        return {
          ...item,
          updated: item.updated_date,
        };
      }, []),
    };
  });
}
